module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1031-min.af04990d.jpg";